import React, {useEffect, useState} from 'react';
import {motion} from 'framer-motion';
import {useARStore} from 'stores';

interface IARButtonCamera {
  onScreenshot: () => void;
}

const ARButtonCamera = ({onScreenshot}: IARButtonCamera) => {
  const [triggerCount, setTriggerCount] = useState(0);
  const isModelInteractiveRef = useARStore(s => s.isModelInteractiveRef);

  const handleScreenshot = () => {
    setTriggerCount(c => c + 1);
    onScreenshot();
  };

  useEffect(() => {
    navigator.permissions.query({name: 'camera'}).then(result => {
      if (result.state === 'denied') {
        location.reload();
      }
    });
  }, []);

  return (
    <>
      <motion.div
        key={triggerCount}
        className="absolute inset-0 bg-white z-10 pointer-events-none"
        initial={{opacity: 1}}
        animate={{opacity: 0}}
        transition={{duration: 0.5}}
      />
      <button
        type="button"
        onClick={handleScreenshot}
        onTouchStart={() => (isModelInteractiveRef.current = false)}
        onTouchEnd={() => (isModelInteractiveRef.current = true)}
        className="absolute bottom-6 left-[50%] transform -translate-x-[50%] flex justify-center items-center bg-white rounded-full size-16 transition duration-300 active:scale-95">
        <div className="flex justify-center items-center rounded-full bg-black size-14">
          <div className="size-12 rounded-full bg-white"></div>
        </div>
      </button>
    </>
  );
};

export default React.memo(ARButtonCamera);
